import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import priceModalThemes from "./themes/index.js";
export const InfoPrice = styled.div.withConfig({
    displayName: "styled__InfoPrice",
    componentId: "sc-91446237-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	position: absolute;
	background-color: ${({ theme  })=>theme.colors.secondary.base};
	color: ${({ theme  })=>theme.colors.white.base};
	bottom: 8px;
	right: 0;
	justify-content: center;
	align-items: center;
	padding: 10px 20px;

	i {
		${FontMixin({
    size: 'largest',
    weight: 'medium',
    height: 'larger'
})}
	}

	${({ theme  })=>priceModalThemes[theme.id]?.InfoPrice?.()}
`;
export const PriceAmounts = styled.div.withConfig({
    displayName: "styled__PriceAmounts",
    componentId: "sc-91446237-1"
})`
	${FlexMixin({
    direction: 'column',
    align: 'end'
})}
`;
export const PriceTop = styled.div.withConfig({
    displayName: "styled__PriceTop",
    componentId: "sc-91446237-2"
})`
	${FlexMixin({
    justify: 'flex-end',
    align: 'flex-end'
})}

	& .from {
		margin-right: 2px;
		margin-bottom: 1px;
		${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'medium'
})}
	}

	& .old-price {
		text-decoration: line-through;
		${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})}
	}
`;
export const PriceCurrent = styled.span.withConfig({
    displayName: "styled__PriceCurrent",
    componentId: "sc-91446237-3"
})`
	${FontMixin({
    size: 'largest',
    weight: 'medium',
    height: 'larger'
})}
`;
export const PricePaxValue = styled.div.withConfig({
    displayName: "styled__PricePaxValue",
    componentId: "sc-91446237-4"
})`
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'small'
})}

	& .per-person {
		margin-right: 2px;
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'small'
})}
	}
`;

//# sourceMappingURL=styled.js.map